/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';

/**
 * person data (without patient folder) of appointment
 * @export
 * @interface PersonAppointmentRequest
 */
export interface PersonAppointmentRequest {
    /**
     * the unique identifier of person appointment
     * @type {string}
     * @memberof PersonAppointmentRequest
     */
    personAppointmentId?: string;
    /**
     * the lastname of person appointment
     * @type {string}
     * @memberof PersonAppointmentRequest
     */
    lastname?: string;
    /**
     * the firstname of person appointment
     * @type {string}
     * @memberof PersonAppointmentRequest
     */
    firstname?: string;
    /**
     * he email of person appointment
     * @type {string}
     * @memberof PersonAppointmentRequest
     */
    email?: string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof PersonAppointmentRequest
     */
    phoneNumber?: PhoneNumber;
}

/**
 * Check if a given object implements the PersonAppointmentRequest interface.
 */
export function instanceOfPersonAppointmentRequest(value: object): value is PersonAppointmentRequest {
    return true;
}

export function PersonAppointmentRequestFromJSON(json: any): PersonAppointmentRequest {
    return PersonAppointmentRequestFromJSONTyped(json, false);
}

export function PersonAppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonAppointmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'personAppointmentId': json['personAppointmentId'] == null ? undefined : json['personAppointmentId'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberFromJSON(json['phoneNumber']),
    };
}

export function PersonAppointmentRequestToJSON(json: any): PersonAppointmentRequest {
    return PersonAppointmentRequestToJSONTyped(json, false);
}

export function PersonAppointmentRequestToJSONTyped(value?: PersonAppointmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personAppointmentId': value['personAppointmentId'],
        'lastname': value['lastname'],
        'firstname': value['firstname'],
        'email': value['email'],
        'phoneNumber': PhoneNumberToJSON(value['phoneNumber']),
    };
}

